import templateUrl from "emun.auth/permissions/permission-list-manager.htm";
import controller from "emun.auth/permissions/permission-list-manager.controller";

export default {
  bindings: {},
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
